import * as z from 'zod';

export const SpaceCoolingSchema = z.object({
  systems: z.array(z.string()).optional(), // index 0: primary / index 1: secondary
});

export type SpaceCooling = z.infer<typeof SpaceCoolingSchema>;
